module.exports = __webpack_public_path__ + "static/media/img-goal-1.7fb64b33.jpg";